import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Tab from '@mui/material/Tab'
import { ReactNode } from 'react'
import CustomButton from '../components/Button'

export interface CustomTab {
    value: string
    label: string | ReactNode
    content: ReactNode
    onChange?: () => void
}

interface Props {
    value: string
    tabs: Array<CustomTab>
    setValue: (value: string) => void
    className?: string
    type?: 'text' | 'buttons'
    gap?: number
    fullWidth?: boolean
}
const CustomTabs = ({
    className,
    setValue,
    tabs,
    value,
    type = 'text',
    gap = 0,
    fullWidth = false,
}: Props) => {
    const handleChange = (_: React.SyntheticEvent, newValue: string) => {
        setValue(newValue)
    }

    const handleChangeTab = (
        _: React.SyntheticEvent,
        newValue: string,
        tabFunction: () => void,
    ) => {
        setValue(newValue)
        tabFunction()
    }

    const gapStyle = `gap-${gap}`
    const gridCols = `grid-cols-${tabs.length}`

    return (
        <div className={`-:w-full ${className}`}>
            <TabContext value={value}>
                <TabList
                    TabIndicatorProps={{
                        className: 'bg-primary',
                    }}
                    onChange={handleChange}
                    centered
                    className="w-full"
                >
                    {type === 'text' ? (
                        tabs.map((tab) => (
                            <Tab
                                key={tab.value}
                                className="text-gray hover:text-secondary [&.Mui-selected]:text-secondary w-full"
                                label={tab.label}
                                value={tab.value}
                                disableRipple
                            />
                        ))
                    ) : (
                        <div
                            className={`${fullWidth ? `w-full grid ${gridCols}` : 'flex w-full'} ${gapStyle}`}
                        >
                            {tabs.map((tab) => (
                                <CustomButton
                                    key={tab.value}
                                    onClick={(e) => {
                                        if (tab.onChange) {
                                            handleChangeTab(e, tab.value, tab.onChange)
                                        } else {
                                            handleChange(e, tab.value)
                                        }
                                    }}
                                    secondary={tab.value !== value}
                                    disableElevation
                                    className="w-full h-fit overflow-hidden whitespace-normal break-words md:whitespace-nowrap text-sm"
                                >
                                    {tab.label}
                                </CustomButton>
                            ))}
                        </div>
                    )}
                </TabList>
                {tabs.map((tab) => (
                    <TabPanel
                        key={tab.value}
                        value={tab.value}
                        className="p-0"
                    >
                        {tab.content}
                    </TabPanel>
                ))}
            </TabContext>
        </div>
    )
}

export default CustomTabs
